var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 18,
  viewBox: "0 0 19 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#313D48",
  fillRule: "evenodd",
  d: "M12.131 17.125V9.604l6.39-6.407c.192-.191.298-.452.295-.724v-.947A.557.557 0 0 0 18.26.97H1.547a.557.557 0 0 0-.557.557v.93c0 .266.106.521.295.708l6.39 6.485v5.682l4.456 1.794z"
})));
export default __webpack_public_path__ + "teg/media/filter.f5b7f62a.svg";
export { SvgComponent as ReactComponent };